import { Button, Form, Select } from "antd";
import React from "react";

function Amenities() {
  return (
    <>
      <Form.Item label="Cats Allowed" name="catsAllowed">
        <Select options={[{ value: "Yes" }, { value: "No" }]} />
      </Form.Item>
      <Form.Item label="Dogs Allowed" name="dogsAllowed">
        <Select
          options={[
            { value: "Large & Small" },
            { value: "Small Only" },
            { value: "No" },
          ]}
        />
      </Form.Item>
      <Form.Item label="Amenities" name="amenities">
        <Select
          mode="tags"
          tokenSeparators={[]}
          options={[
            { value: "storage shed in the backyard with metal cabinets" },
            { value: "central ac/heat" },
            { value: "Air conditioning" },
            { value: "central heat/air" },
          ]}
        />
      </Form.Item>
      {/* <Form.Item label=" ">
        <Button type="link">Manage Tags</Button>
      </Form.Item> */}
    </>
  );
}

export default Amenities;
